var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VxDialogView',{attrs:{"fullscreen":true},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})]},proxy:true}],null,true)},[_c('VxWalkthru',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }